import React, { Component } from 'react'

import classNames from 'classnames';

import { Button, Col, Row } from "react-bootstrap";

import { connect } from 'react-redux';

import ProjectSelect from 'components/ProjectSelect/ProjectSelect';
import ProductTypeahead from 'components/ProductTypeahead/ProductTypeahead';
import ProductSelectMap from 'components/ProductSelectMap/ProductSelectMap';
import ProductSelectedInfo from 'components/ProductSelectedInfo/ProductSelectedInfo';
import Loader from "components/elements/loader/Loader";

import { updateProject, updateProduct } from 'reducers/saleorder/saleorderActions';
import { showWarningMessage, showSuccessfulMessage } from 'reducers/application/applicationActions';

import { fetchCommercialProjects } from 'reducers/project/projectActions';

class ProductSelectionStep extends Component {

  constructor(props) {
    super(props);

    console.log("Constructor project", this.props.project);

    if (this.props.project != null) {
      this.state = {
        projectError: null,
        productError: null,
        loadingMap: true
      }
    } else {
      this.state = {
        projectError: null,
        productError: null,
        loadingMap: false
      }
    }
  }

  isValidated() {
    this.cleanErrors();
    if (this.props.project == null) {
      this.props.showWarningMessage("Por favor seleccione un proyecto");
      this.setState({ projectError: "Por favor seleccione un proyecto" });
      return;
    }

    if (this.props.product == null) {
      this.props.showWarningMessage("Por favor seleccione un lote");
      this.setState({ productError: "Por favor seleccione un lote" });
      return;
    }
    if (!this.props.productEdit) {
      this.props.jumpToStep(1);
    }
    return true;
  }

  cleanProjectError() {
    this.setState({ projectError: null });
  }

  cleanProductError() {
    this.setState({ productError: null });
  }

  cleanErrors() {
    this.cleanProjectError();
    this.cleanProductError();
  }

  handleProjectSelectionChange(selectedProject) {
    if (selectedProject != null) {
      this.cleanProjectError();
      this.setState({ loadingMap: true });
    }
    this.props.updateProject(selectedProject);
    this.clearTypeaheadText();
  }

  handleProductSelectionChange(selectedProduct) {
    if (selectedProduct != null) this.cleanProductError();
    this.props.updateProduct(selectedProduct);
    if (selectedProduct != null) {
      this.props.showSuccessfulMessage("Lote seleccionado");
    }
  }

  clearTypeaheadText() {
    if (this.productTypeahead != undefined) {
      this.productTypeahead.clearText();
    }
  }

  updateProduct = () => {
    if (this.isValidated()) {
      let promise = new Promise((resolve, reject) => {
        this.setState({
          loadingMap: true
        });
        this.props.postUpdateProduct(
          this.props.saleOrderId,
          this.props.product.id,
          resolve,
          reject
        );
      });

      promise.then(() => {
        this.setState({
          loadingMap: false
        });
        this.props.showSuccessfulMessage("Lote Actualizado correctamente");
      }, () => {
        this.setState({
          loadingMap: false
        });
      });
    }
  }

  isProductEditable = () => {
    if (this.props.orderStatus) {
      return this.props.orderStatus === 'DRAFT';
    }
    return true;
  }

  render() {
    const { projectError, productError } = this.state;
    const projectClass = classNames('form-group',
      { 'has-error': projectError != null }
    );
    const productClass = classNames('form-group',
      { 'has-error': productError != null }
    );
    return (
      <Col className="wizard-step">
        <Row className="justify-content-end wizard-buttons">

          {!this.props.productEdit ?
            <Button className="bg-light-secondary"
              onClick={() => this.isValidated()}>
              Siguiente
                    </Button>
            :
            <Button className={this.isProductEditable() ? "bg-light-secondary" : "hide"}
              disabled={this.state.loadingMap}
              onClick={() => this.updateProduct()}>
              Guardar
                    </Button>
          }

        </Row>
        <Row>
          <div className="col-12 ">
            <h5 className="">Seleccionar un lote</h5>
          </div>
          <Col className="col-12 no-padding no-margin">
            <Row className="no-padding no-margin">
              <Col md="4">
                <div className={projectClass}>
                  <ProjectSelect
                    disabled={!this.isProductEditable()}
                    placeholder={"Proyectos Comerciales..."}
                    fetchProjects={() => this.props.fetchCommercialProjects()}
                    projects={this.props.commercialProjects}
                    selection={this.props.project}
                    handleChange={(project) => this.handleProjectSelectionChange(project)}
                  />
                  <span className="help-block">{projectError}</span>
                </div>
              </Col>
              {this.props.project && !this.state.loadingMap && <Col md={4} className={productClass}>
                <ProductTypeahead
                  disabled={!this.isProductEditable()}
                  onRef={ref => (this.productTypeahead = ref)}
                  projectId={this.props.project.value}
                  project={this.props.project}
                  selection={this.props.product}
                  handleChange={(product) => this.handleProductSelectionChange(product)} />
                <span className="help-block">{productError}</span>
              </Col>
              }
              <Col md={4}>
                {
                  this.props.product != null &&
                  <div className="form-group">
                    <ProductSelectedInfo product={this.props.product} />
                  </div>
                }
              </Col>
            </Row>
          </Col>

          <div className="w-100">
            <Loader show={true} classes={this.state.loadingMap ? "map-default-height" : "d-none"} />
            <div className={this.state.loadingMap ? "d-none" : "d-block map-container"}>
              <ProductSelectMap
                project={this.props.project}
                product={this.props.product}
                handleChange={(product) => this.handleProductSelectionChange(product)}
                handleLoadingMap={(value) => this.setState({ loadingMap: value })}
              />
            </div>
          </div>
        </Row>
      </Col>
    )
  }
}
const mapStateToProps = state => ({
  product: state.saleorder.product,
  project: state.saleorder.project,
  commercialProjects: state.project.items,
});
export default connect(
  mapStateToProps,
  {
    updateProject,
    updateProduct,
    showWarningMessage,
    showSuccessfulMessage,
    fetchCommercialProjects
  },
  null,
  { withRef: true }
)(ProductSelectionStep);


// WEBPACK FOOTER //
// ./src/components/SalesWizard/Steps/ProductSelectionStep.jsx